// Shared data shapes for the case study editor and its section components.
// Storage format is unchanged from the old editor.

export interface CaseStudyStat {
  id: string;
  value: string;
  label: string;
  sortOrder: number;
}

export interface ProcessStep {
  id: string;
  title: string;
  description: string;
  sortOrder: number;
}

export interface CaseStudyResult {
  id: string;
  title: string;
  description: string;
  iconName?: string;
  sortOrder: number;
}

export interface GalleryItem {
  id: string;
  iconName: string;
  label: string;
  imageUrl?: string;
  isLarge: boolean;
  sortOrder: number;
}

export const generateId = (): string => `item-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
